import React from "react";
import { StyledH2 } from "@aureskonnect/react-ui";
import { useTranslation } from "react-i18next";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import {
    DynamicTable,
    customColumnProps,
} from "@maherunlocker/custom-react-table";
import { useSnapshot } from "valtio";

import { capitalize } from "../../../helpers/general";
import { resetStore } from "../../../pages/Applications/DeviceAssociateModal/store";

import { store } from "../../../components/VerticalLayout/store";
import { store as storeData } from "./store";

import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import classnames from "classnames";
import CustomColumnDisplay from "@components/Common/CustomColumnDisplay";
import { useAuthHeader } from "../../../api/headersKeycloak";

export default function HistoryModal({ isModalOpened, setIsModalOpened }: any) {
    const { t } = useTranslation();
    const getAuthHeader = useAuthHeader();
    const { selectedLogo } = useSnapshot(storeData);
    const { franchiseID, userID } = useSnapshot(store);
    const i18nextLng = localStorage.getItem("i18nextLng") || "fr";
    const [dataIsUpdated, setDataIsUpdated] = React.useState<boolean | number>(
        false
    );
    const [, setArrayIds] = React.useState<any[]>([]);
    const [data, setData] = React.useState<any>({});
    const [filterActive, setLocalFilterActive] = React.useState<boolean>(false);

    const ActionColumn = (e: any) => {
        return e.selectedRow.subRows === undefined ? <div></div> : null;
    };

    const url = `${
        process.env.REACT_APP_API_V2_URL
    }/settings/general/logo/history?userId=${userID}&franchiseId=${franchiseID}&logo=${selectedLogo
        .map((el: any) => JSON.stringify(el))
        .join()}`;

    let arrayOfCustomColumns: customColumnProps[] = [
        {
            indexOFColumn: 2,
            columnName: t("Actions"),
            customJsx: (e: any) => {
                return (
                    <CustomColumnDisplay text={e.selectedRow[t("Actions")]} />
                );
            },
        },
        {
            indexOFColumn: 3,
            columnName: t("Before edit"),
            customJsx: (e: any) => {
                const value = e?.selectedRow?.[t("Before edit")];
                if (value === null || value === undefined) {
                    return <CustomColumnDisplay text="—" />;
                }
                const parts =
                    typeof value === "string" && value.includes(",")
                        ? value.split(",").map((x) => x.trim())
                        : [value];

                return (
                    <div
                        style={{
                            display: "flex",
                            gap: "8px",
                            alignItems: "center",
                        }}
                    >
                        {parts.map((item, idx) => {
                            if (isImageUrl(item)) {
                                return (
                                    <img
                                        key={idx}
                                        src={item}
                                        alt="preview"
                                        style={{
                                            height: 25,
                                            width: 35,
                                            objectFit: "cover",
                                            borderRadius: 4,
                                        }}
                                    />
                                );
                            }
                            const text =
                                typeof item === "object"
                                    ? JSON.stringify(item)
                                    : String(item);

                            return (
                                <CustomColumnDisplay key={idx} text={text} />
                            );
                        })}
                    </div>
                );
            },
        },
        {
            indexOFColumn: 4,
            columnName: t("After edit"),
            customJsx: (e: any) => {
                const value = e?.selectedRow?.[t("After edit")];
                if (value === null || value === undefined) {
                    return <CustomColumnDisplay text="—" />;
                }
                const parts =
                    typeof value === "string" && value.includes(",")
                        ? value.split(",").map((x) => x.trim())
                        : [value];

                return (
                    <div
                        style={{
                            display: "flex",
                            gap: "8px",
                            alignItems: "center",
                        }}
                    >
                        {parts.map((item, idx) => {
                            if (isImageUrl(item)) {
                                return (
                                    <img
                                        key={idx}
                                        src={item}
                                        alt="preview"
                                        style={{
                                            height: 25,
                                            width: 35,
                                            objectFit: "cover",
                                            borderRadius: 4,
                                        }}
                                    />
                                );
                            }
                            const text =
                                typeof item === "object"
                                    ? JSON.stringify(item)
                                    : String(item);

                            return (
                                <CustomColumnDisplay key={idx} text={text} />
                            );
                        })}
                    </div>
                );
            },
        },
    ];

    React.useEffect(() => {
        setArrayIds(selectedLogo.map((el) => el.Id));
    }, [selectedLogo]);

    return (
        <React.Fragment>
            <Modal
                centered
                backdrop="static"
                fade={false}
                scrollable
                className="modal-wrapper__clz"
                isOpen={isModalOpened}
            >
                <ModalHeader
                    className="lgo_icn_HSclose"
                    toggle={() => {
                        setIsModalOpened!(!isModalOpened);
                        resetStore();
                    }}
                >
                    <StyledH2 className="lgo_txt_HStitleHistory">
                        {capitalize(t("Historical"))}
                    </StyledH2>
                </ModalHeader>

                <ModalBody>
                    <div
                        className={`${classnames("title__clz", {
                            "not-allowed-icon__clz": selectedLogo.length > 1,
                        })}`}
                    >
                        {t("Logo")} :{" "}
                        {selectedLogo.length > 1
                            ? null
                            : data?.data !== undefined
                            ? data?.data![0][t("Designation")]
                            : ""}
                    </div>
                    <DynamicTable
                        url={url}
                        canResize
                        actionColumn={ActionColumn}
                        showGlobalFilter
                        showFilter
                        requestHeader={{
                            "Accept-Language": i18nextLng,
                            ...getAuthHeader,
                        }}
                        setLocalFilterActive={setLocalFilterActive}
                        filterActive={filterActive}
                        setDataIsUpdated={setDataIsUpdated}
                        dataIsUpdated={dataIsUpdated}
                        elevationTable={1}
                        minHeight="500px"
                        maxHeight="500px"
                        name="historyLogo"
                        arrayOfCustomColumns={arrayOfCustomColumns}
                        setData={setData}
                    />
                </ModalBody>
                <ModalFooter className="border-top-0">
                    <CustomMainColorButton
                        rounded
                        variant="primary"
                        className="lgo_btn_HSclose"
                        onClick={() => setIsModalOpened(!isModalOpened)}
                    >
                        {t("Close")}
                    </CustomMainColorButton>
                </ModalFooter>
            </Modal>
        </React.Fragment>
    );
}

const isImageUrl = (value: any): boolean => {
    if (typeof value !== "string") return false;
    try {
        new URL(value);
    } catch {
        return false;
    }
    return /\.(jpg|jpeg|png|gif|webp|svg)$/i.test(value);
};
